import React from 'react';
import InquiryList from '../components/InquiryList';

/** Leads & Inquiries: every customer inquiry. */
const Leads: React.FC = () => <InquiryList />;

export default Leads;
